/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
}

.#{$prefix}badges-wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;

  @include for-size(phone) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 16px;
    row-gap: 24px;

    &.#{$prefix}mobile-width-3col {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  &.#{$prefix}alignment-left {
    justify-content: flex-start;
  }

  &.#{$prefix}alignment-center {
    justify-content: center;
  }

  &.#{$prefix}alignment-right {
    justify-content: flex-end;
  }

  &.#{$prefix}alignment-space-between {
    justify-content: space-between;
  }

  &.#{$prefix}alignment-space-around {
    justify-content: space-around;
  }

  &.#{$prefix}alignment-space-evenly {
    justify-content: space-evenly;
  }

  .#{$prefix}badge-wrapper {
    position: relative;
    width: auto;
    margin: 12px;

    @include for-size(desktop) {
      margin: 16px;
    }

    @include for-size(tablet) {
      margin: 12px;
    }

    @include for-size(phone) {
      margin: 0;
      width: 100%;
    }
  }
}
